export default "__VITE_ASSET__2df48aea__"